<template>
    <div id="Edit_ProfilePic" class="p-3 d-flex flex-column justify-content-between">
        <template v-if="!showCropper">
            <h6 class="fw-semibold pb-3">Change your profile picture</h6>

            <div>
                <div v-if="profilePic" class="avatar">
                    <img :src="profilePic" class="avatar-img" alt="Profile" />
                </div>
                <div v-else :class="`ava-initials ava-xl ava-initials-${profileColor} d-flex m-auto`">
                    {{ userInitials }}
                </div>

                <div class="d-flex justify-content-center py-3 gap-4 fs-6 cursor-pointer">
                    <span class="d-flex align-items-center gap-2" @click="openUploader"
                        ><img src="../../../assets/images/chat/upload.svg" />Upload</span
                    >
                    <input type="file" ref="fileInput" class="d-none" accept="image/*" @change="onFileChange" />
                    <span v-if="profilePic" class="d-flex align-items-center gap-2" @click="removeProfilePic"
                        ><img src="../../../assets/images/chat/delete.svg" />Remove</span
                    >
                </div>
            </div>

            <div class="d-flex align-items-center justify-content-center mt-3">
                <button type="button" class="btn btn-light border border-secondary me-2" @click="closeDialog()">
                    Close
                </button>
                <button type="button" class="btn btn-primary border border-primary" @click="saveProfilePic()">
                    Save
                </button>
            </div>
        </template>

        <template v-else>
            <h6 class="fw-semibold">Crop your image</h6>

            <Cropper
                v-if="uploadImage"
                ref="cropperRef"
                class="cropper-container"
                :src="uploadImage"
                :stencil-component="CircleStencil"
                :stencil-props="{ movable: true, resizable: true }"
                :auto-zoom="true"
                :min-zoom="1"
            />

            <div class="d-flex justify-content-center gap-4 mt-2">
                <button type="button" class="btn btn-light border border-secondary" @click="cancelCrop">Cancel</button>
                <button type="button" class="btn btn-primary border border-primary" @click="saveCropped">
                    Confirm
                </button>
            </div>
        </template>
    </div>
</template>

<script lang="ts" src="./UpdateUserProfilePic.ts"></script>
<style src="./UpdateUserProfilePic.scss"></style>
